var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"align-center justify-center",attrs:{"app":""}},[_c('span',[_vm._v("© 2019-"+_vm._s(_vm.year)+" S2A - "+_vm._s(_vm.$t("right")))])])}
var staticRenderFns = []

export { render, staticRenderFns }